export const version = "4.0.9";
export const build = "esm";
//# sourceMappingURL=version.js.map
